<div class="container p-5 product-detail-description">
  <div class="row d-flex align-items-lg-center">
    <div class="col-12 col-lg-4 order-lg-5" *ngIf="imageId">
      <app-catalog-graphic imageClasses="border d-block mx-auto img-fluid"
                           [imageId]="imageId"
                           [imageSize]="256">
      </app-catalog-graphic>
    </div>
    <div class="display-md-none"></div>
    <div class="col-12 col-lg-8 order-lg-1 mt-5 mt-lg-0">
      <span>{{ vendorName }}</span>
      <h1 class="pb-2">{{ name }}</h1>
      <p>{{ shortDescription }}</p>
    </div>
  </div>
</div>

<app-license-info *ngIf="hasOfferings" [offerings]="allOfferings"></app-license-info>
<app-license-expiration-warning *ngIf="hasOfferings" [offerings]="allOfferings"></app-license-expiration-warning>

<div *ngIf="hasOfferings">
  <app-product-details-by-license [offerings]="studentOfferings"
                                  [product]="product"
                                  licenseTitle="Student"
                                  (addToCartEmitter)="addToCart($event)">
  </app-product-details-by-license>

  <div *ngIf="displayStudentEligibilityError || displayLicenseErrors.student">
    <app-purchase-not-allowed-warning [displayStudentEligiblityError]="displayStudentEligibilityError"
                                      [displayLicenseErrors]="displayLicenseErrors">
    </app-purchase-not-allowed-warning>
  </div>

  <div class="container px-4 px-lg-0 mb-5" *ngIf="loadOtherLicenses()">
    <hr class="bg-medium" role="layout">
  </div>

  <app-product-details-by-license *ngIf="loadOtherLicenses()"
                                  [offerings]="employeeOfferings"
                                  [product]="product"
                                  licenseTitle="Employee"
                                  (addToCartEmitter)="addToCart($event)">
  </app-product-details-by-license>

  <div *ngIf="displayLicenseErrors.employee">
    <app-purchase-not-allowed-warning [displayStudentEligiblityError]="displayStudentEligibilityError"
                                      [displayLicenseErrors]="displayLicenseErrors">
    </app-purchase-not-allowed-warning>
  </div>

  <div class="container px-4 px-lg-0 mb-5" *ngIf="loadOtherLicenses()">
    <hr class="bg-medium" role="layout">
  </div>

  <app-product-details-by-license *ngIf="loadOtherLicenses()"
                                  [offerings]="universityOfferings"
                                  [product]="product"
                                  licenseTitle="University"
                                  (addToCartEmitter)="addToCart($event)">
  </app-product-details-by-license>

  <div *ngIf="displayLicenseErrors.university">
    <app-purchase-not-allowed-warning [displayStudentEligiblityError]="displayStudentEligibilityError"
                                      [displayLicenseErrors]="displayLicenseErrors">
    </app-purchase-not-allowed-warning>
  </div>

</div>

<div id="licenseDetails" class="container px-4 px-lg-0 mb-5">
  <hr class="bg-medium" role="layout">
  <div class="row px-0">
    <div class="col px-lg-0">
      <h2>License Details</h2>
    </div>
  </div>

  <div class="row mb-3" *ngIf="hasOfferings && !!licenseEndDate">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">License Term</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2 license-terms-dates">
        {{ licenseStartDate | date:'longDate' }} - {{ licenseEndDate | date:'longDate' }}
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">License Types</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2">
        OSL has three license <strong><u>types</u></strong> - University, Employee, and Student. The license type you
        should purchase is determined by who technically <strong>owns</strong> the device that the software will be
        installed, activated, and used on. Not all three license types are available on some products.
      </p>
    </div>
  </div>

  <div class="row mb-3" *ngIf="hasStudentOfferings">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">Student License</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2">
        The Student License type only allows for the purchased software to be installed, activated, and used on a
        device that was purchased or leased by or for the student <u>and</u> was paid for with personal funds and not
        university funds. This type of device is student owned. Because the device is student owned
        <strong>we must charge state sales tax</strong> for the software purchase.
      </p>
    </div>
  </div>
  <div class="row mb-3" *ngIf="hasEmployeeOfferings">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">Employee License</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2">
        The Employee License type only allows for the purchased software to be installed, activated, and used on
        a device that was purchased or leased by or for the employee <u>and</u> was paid for with personal funds and not
        university funds. This type of device is employee owned. Because the device is employee owned
        <strong>we must charge state sales tax</strong> for the software purchase. For Work-at-Home purposes,
        in order for an employee to utilize the University License type and not pay state sales tax, the software
        product <strong><u>must</u></strong> be installed, activated, and used on a university owned device that
        was paid for using university funds.
      </p>
    </div>
  </div>
  <div class="row mb-3" *ngIf="hasUniversityOfferings">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">University License</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2">
        The University License type only allows for the purchased software to be installed, activated, and used on
        a device that was either purchased or leased using university funds. This type of device is university owned.
        Because the device is university owned the software purchase is exempt from state sales tax. For Work-at-Home
        purposes, when using the University License type, the device the software product is installed, activated,
        and used on <strong><u>must</u></strong> be a university owned device that was paid for using university funds.
      </p>
    </div>
  </div>
  <div class="row mb-3" *ngIf="hasAnyWithUpgradeProtectionIncluded">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">Maintenance</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2">
        Maintenance is NOT a license, gives you the right to receive updates and upgrade to newer versions, is usually
        included during the initial software licensing term, has an expiration date, and is usually renewable at the
        conclusion of the license term for a fee. If you allow the maintenance to expire you may have to purchase a new
        license to receive newer versions.
      </p>
    </div>
  </div>
  <div class="row mb-3" *ngIf="hasAnyWithUpgradeProtectionOnly">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">Maintenance Only</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <p class="py-2">
        This is NOT a license. Maintenance gives you the right to receive software updates and upgrade the
        software to
        newer versions. Maintenance is usually included during the initial software licensing term.
        Maintenance is
        usually renewable at the conclusion of the contract term. Maintenance has an expiration date. An annual
        renewal
        fee is required to continue the maintenance. If you allow the maintenance on the software to expire, you
        may
        have to purchase a new license to receive newer versions.
      </p>
    </div>
  </div>
  <div *ngIf="vendorUrl || faqUrl" class="row mb-3">
    <div class="col-md-12 col-lg-3 px-lg-0">
      <h4 class="py-2">More Information</h4>
    </div>
    <div class="col-md-12 col-lg-9">
      <div class="py-2 d-grid">
        <a *ngIf="faqUrl" class="text-start text-muted pb-3 btn btn-light btn-lg" role="button"
           [href]="faqUrl" target="_blank">
          Frequently Asked Questions
          <app-caret-right-icon></app-caret-right-icon>
        </a>
        <a class="text-start text-muted pb-3 mt-2 btn btn-light btn-lg vendor" role="button" [href]="vendorUrl"
           target="_blank" *ngIf="vendorUrl">
          Link to Vendor Site
          <app-caret-right-icon></app-caret-right-icon>
        </a>
      </div>
    </div>
  </div>
</div>
